/* unplugin-vue-components disabled */import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id"];
const _hoisted_2 = ["width", "height", "id"];
import { fabric } from 'fabric';
import { useFabricStore } from "@/stores/fabricModule";
import { useConfigurationStore } from '@/stores/configurationModule';
import EditorMask from '@/components/configurator/2dEditor/EditorMask';
import EditorClipPath from '@/components/configurator/2dEditor/EditorClipPath';
import EditorPanelOverlay from '@/components/configurator/2dEditor/EditorPanelOverlay';
import useCanvasEventListeners from '@/composables/2dEditor/useCanvasEventListeners';
import { useCreateEditorImage } from '@/composables/2dEditor/useCreateEditorImage';
import { useCreateEditorText } from '@/composables/2dEditor/useCreateEditorText';
import { useCreateEditorShape } from '@/composables/2dEditor/useCreateEditorShape';
import useFontLoader from '@/composables/fonts/useFontLoader';
import { setControlsSize, queryToObject } from '@/utils/common';
export default {
  __name: 'FabricCanvas',
  props: {
    name: {
      require: true,
      type: String,
      default: 'canvas'
    },
    width: {
      require: true,
      type: Number,
      default: 6
    },
    length: {
      require: true,
      type: Number,
      default: 6
    },
    depth: {
      require: true,
      type: Number,
      default: 6
    },
    type: {
      require: true,
      type: String,
      default: 'Shipping'
    },
    printSide: {
      require: true,
      type: String,
      default: 'outside'
    }
  },
  setup(__props) {
    const {
      loadFont
    } = useFontLoader();
    const $eventBus = inject('bus');
    const queryObject = queryToObject(window.location.search);
    const canvasEl = ref(null);
    const offscreenCanvasEl = ref(null);
    const canvasComponent = ref(null);

    // TEMP
    const {
      theCanvas,
      updateTheCanvas
    } = inject('theCanvas');
    const props = __props;

    // https://vueuse.org/core/useMouse/#custom-extractor
    // const extractor = (event) =>
    // event instanceof Touch || event instanceof TouchEvent ? null : [event.offsetX, event.offsetY]
    const extractor = event => event instanceof PointerEvent ? null : [event.offsetX, event.offsetY];
    const {
      x,
      y,
      sourceType
    } = useMouse({
      target: canvasComponent,
      type: extractor
    });
    let canvas = null;
    let renderStop = true;
    let canvasDisplayWidth = ref(null);
    let canvasDisplayHeight = ref(null);
    let offscreenCtx = null;
    let lastExecutionTime = 0;
    let currentCanvas = '';
    let previousCanvas = '';
    let offscreenCanvas = null;
    const canvasWidth = ref(0);
    const canvasHeight = ref(0);
    const fabricStore = useFabricStore();
    const configurationStore = useConfigurationStore();
    const {
      setBaseObjectSize,
      addOffscreenCanvasId,
      addFabricCanvas,
      setIsActivePanelInside,
      setActiveCanvas,
      setHaveCanvasesBeenModified
    } = configurationStore;
    const {
      configurationId,
      fabricCanvases,
      hasInsidePrinting,
      insideMaterialColor,
      outsideMaterialColor,
      box,
      canvases
    } = storeToRefs(configurationStore);
    const canvasObjects = ref([]);
    const continuosEvent = ref(null);
    const {
      setCanvasDimensions,
      setCanvasScaleFactor
    } = fabricStore;
    const w = ref(box.value.canvasWidth);
    const h = ref(box.value.canvasHeight);
    async function prepare() {
      // @TODO: change how you get element
      // @TODO: set these values in the store
      const workspace = document.getElementById('workspace');
      setBaseObjectSize(box.value.baseObjectSize);
      const _canvasWidth = box.value.canvasWidth;
      const _canvasHeight = box.value.canvasHeight;
      canvasWidth.value = box.value.canvasWidth;
      canvasHeight.value = box.value.canvasHeight;

      // @TODO: 2500? - should be part of some configuration or state
      // const canvasScaleFactor = canvasWidth > 2500 || canvasHeight > 2500 ? 4 : 2
      // setCanvasScaleFactor(canvasScaleFactor)

      // _________________________________________________________________
      // @NOTE: workspace dimensions at this time are not yet updated
      const workspaceArg = _canvasWidth > _canvasHeight ? workspace.offsetWidth : workspace.offsetHeight;
      const canvasLargerDisplayDimension = workspaceArg - 100;
      const canvasSmallerDisplayDimension = canvasLargerDisplayDimension * box.value.ratio;
      if (props.type === 'Shipping') {
        canvasDisplayWidth.value = _canvasWidth >= _canvasHeight ? canvasLargerDisplayDimension : canvasSmallerDisplayDimension;
        canvasDisplayHeight.value = _canvasHeight >= _canvasWidth ? canvasLargerDisplayDimension : canvasSmallerDisplayDimension;
      } else {
        // @NOTE: this covers literature and mailer boxes for who these values are the same
        // once pizza box is added this whole if/else block needs to be changed
        canvasDisplayWidth.value = _canvasWidth >= _canvasHeight ? canvasLargerDisplayDimension : canvasSmallerDisplayDimension;
        canvasDisplayHeight.value = _canvasWidth >= _canvasHeight ? canvasSmallerDisplayDimension : canvasLargerDisplayDimension;
      }
      // _________________________________________________________________

      setCanvasDimensions({
        width: _canvasWidth,
        height: _canvasHeight
      });
      let canvasBackgroundColor;
      if (props.printSide === 'inside') {
        canvasBackgroundColor = hasInsidePrinting.value ? insideMaterialColor.value : 'rgba(255,255,255,1)';
      } else {
        canvasBackgroundColor = outsideMaterialColor.value;
      }

      // NOTE: @TODO: Check if still needed (markRaw)
      // See: https://github.com/fabricjs/fabric.js/issues/7012 for why markRaw is used
      canvas = markRaw(new fabric.Canvas(canvasEl.value, {
        // backgroundColor: canvasBackgroundColor,
        containerClass: 'canvas-wrapper',
        preserveObjectStacking: true,
        selection: true,
        renderOnAddRemove: false,
        enableRetinaScaling: false,
        // This makes selection of object work only when clicking on the object itself
        // as opposed on it's bounding box witch is the default (could be good, need to check performance impact)
        // perPixelTargetFind: true,
        width: _canvasWidth,
        height: _canvasHeight
      }));

      // ==== Performance
      canvas.upperCanvasEl.classList.add(`upper-canvas-${props.printSide}`);
      canvas.lowerCanvasEl.classList.add(`lower-canvas-${props.printSide}`);
      const canvasContinuousEvents = ['object:rotating', 'object:scaling', 'object:moving'];
      canvasContinuousEvents.forEach(event => {
        canvas.on(event, e => {
          requestAnimationFrame(render);
        });
      });
      const canvasEvents = ['object:added', 'object:modified',
      // 'object:over',
      'object:out', 'object:removed', 'object:selected', 'path:created',
      // 'before:selection:cleared',

      'selection:cleared', 'selection:created', 'text:editing:entered', 'text:editing:exited', 'text:selection:changed', 'text:changed'];
      canvasEvents.forEach(event => {
        canvas.on(event, () => {
          // cancelAnimationFrame(continuosEvent.value)
          // continuosEvent.value = null
          requestAnimationFrame(render);
        });
      });
      // ====

      // TEMP
      updateTheCanvas(canvas);
      canvas.setDimensions({
        width: canvasDisplayWidth.value + 'px',
        height: canvasDisplayHeight.value + 'px'
      }, {
        cssOnly: true
      });
      setCanvasScaleFactor(canvas.width / canvasDisplayWidth.value);

      // Since the difference of the canvas display size and
      // it's internal canvas size is different for different box sizes
      // we need to adjust the corner size and control offsets to be consistent
      setControlsSize(box.value, canvasDisplayWidth.value);

      // @TODO REMOVE
      fabric.Object.prototype.cornerStrokeColor = '#555555';
      fabric.Object.prototype.transparentCorners = false;
      addFabricCanvas({
        fabricInstance: canvas,
        printSide: props.printSide
      });

      //  OFFSCREEN CANVAS ===============================
      offscreenCanvas = offscreenCanvasEl.value;
      offscreenCtx = offscreenCanvas.getContext('2d');
      // OFFSCREEN CANVAS ================================

      addOffscreenCanvasId({
        offscreenCanvasId: offscreenCanvasId.value,
        printSide: props.printSide
      });
      if (configurationId.value !== null && queryObject.id) {
        const canvasToLoad = canvases.value.find(c => c.position === props.printSide);
        canvasObjects.value = canvasToLoad.objects;
        const uniqueFontFamilies = new Set();
        if (canvasObjects.value.length > 0) {
          for (const object of canvasObjects.value) {
            if (object.type === 'i-text') {
              uniqueFontFamilies.add(object.fontFamily);
            }
          }
        }
        const fontPromises = Array.from(uniqueFontFamilies).map(loadFont);
        await Promise.all(fontPromises);
        canvas.loadFromJSON(canvasToLoad, canvas.renderAll.bind(canvas));
      } else {
        const backgroundShape = new fabric.Rect({
          id: 'background',
          width: _canvasWidth,
          height: _canvasHeight,
          fill: canvasBackgroundColor,
          selectable: false,
          evented: false,
          zIndex: -1
        });
        canvas.add(backgroundShape);
      }
      currentCanvas = JSON.stringify(canvas.toJSON());
    }
    const offscreenCanvasId = computed(() => `${props.name}Offscreen`);
    function render() {
      // // ================================
      if (renderStop) {
        return;
      }

      // console.log('isCanvasRenderingRendering...')

      const currentTime = Date.now();
      const IS_RENDERING = currentTime - lastExecutionTime >= 34;
      setHaveCanvasesBeenModified(true);
      canvas.renderAll();
      if (IS_RENDERING) {
        lastExecutionTime = currentTime;
        // drawImageOntoOffscreenCanvas()
      }
    }
    function drawImageOntoOffscreenCanvas() {
      // const scaling = 0.8

      const imageDataURL = canvas.toDataURL({
        format: 'png',
        excludeControls: true,
        quality: 1,
        enableRetinaScaling: false
        // multiplier: scaling
      });
      const image = new Image();
      image.src = imageDataURL;
      image.onload = function () {
        offscreenCtx.drawImage(image, 0, 0, offscreenCanvas.width, offscreenCanvas.height);
      };
    }
    async function addObjects() {
      for (let object of canvasObjects.value) {
        let objectToAdd = null;
        if (object.type === 'i-text') {
          objectToAdd = await useCreateEditorText(object);
        }
        if (object.type === 'image') {
          objectToAdd = await useCreateEditorImage(object);
        }
        if (object.type === 'path') {
          objectToAdd = await useCreateEditorShape(object);
        }
        if (objectToAdd) {
          $eventBus.$emit("object-added", objectToAdd);
        }
      }
    }
    onMounted(async () => {
      await prepare();
      useCanvasEventListeners(canvas, props.printSide);
      renderStop = false;
      // addObjects()
      requestAnimationFrame(render);
    });
    onBeforeUnmount(() => {
      renderStop = true;
      canvas?.dispose();
    });

    // Component events
    function onMouseClickCanvasComponent(event) {
      setIsActivePanelInside(props.printSide === 'inside');
      const activeCanvasIndex = props.printSide === 'inside' ? 1 : 0;
      setActiveCanvas(fabricCanvases.value[activeCanvasIndex]);
      $eventBus.$emit(`canvas-mouse-click`, {
        event,
        printSide: props.printSide
      });
    }
    function onMouseleave() {
      x.value = -1;
      y.value = -1;
    }
    const rotateInsidePrint = computed(() => {
      return props.printSide === 'inside' ? 'transform: matrix(-1, 0, 0, -1, 0, 0)' : '';
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: __props.name,
        ref_key: "canvasComponent",
        ref: canvasComponent,
        class: "container-clip-path relative",
        style: _normalizeStyle({
          'clip-path': `url('#clipPath-${__props.printSide}')`
        }),
        onClick: onMouseClickCanvasComponent,
        onMouseleave: onMouseleave
      }, [_createElementVNode("canvas", {
        ref_key: "canvasEl",
        ref: canvasEl
      }, null, 512), _createElementVNode("canvas", {
        width: _unref(w),
        height: _unref(h),
        id: _unref(offscreenCanvasId),
        class: "offscreenCanvas hidden",
        ref_key: "offscreenCanvasEl",
        ref: offscreenCanvasEl
      }, null, 8, _hoisted_2), _createVNode(_unref(EditorMask), {
        printSide: __props.printSide
      }, null, 8, ["printSide"]), _createVNode(_unref(EditorClipPath), {
        printSide: __props.printSide
      }, null, 8, ["printSide"]), _createVNode(_unref(EditorPanelOverlay), {
        mouseX: _unref(x),
        mouseY: _unref(y),
        sourceType: _unref(sourceType),
        printSide: __props.printSide,
        canvasName: __props.name,
        canvasDisplayHeight: _unref(canvasDisplayHeight),
        canvasDisplayWidth: _unref(canvasDisplayWidth)
      }, null, 8, ["mouseX", "mouseY", "sourceType", "printSide", "canvasName", "canvasDisplayHeight", "canvasDisplayWidth"])], 44, _hoisted_1);
    };
  }
};